import { render } from "./FuneralViewFormType4.vue?vue&type=template&id=f0068c88&lang=true"
import script from "./FuneralViewFormType4.vue?vue&type=script&lang=js"
export * from "./FuneralViewFormType4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__